<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="row">

  <div class="columnnbv1">
    <div class="position-fixed-scans2 border-right2  height-100pe">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 padding-right-0px">
        <!--<div class="row"></div>-->
        <div class="card height-100vh">
          <div class="card-header wh-header border-bottom padding-bottom-0px">
            <div class="row">
              <div class="col-md-12">
                <label class="margin-bottom-0px">Patient Details</label>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row border-bottom-2px" *ngIf="SelectedPatientFormattedCode">
              <!--<div class="padding-left-14px padding-right-14px padding-bottom-14px"></div>-->
              <!--<div class="card"></div>-->
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="row">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <img class="img-circle-50" [src]='SelectedPatientFormattedCode.PatientImageFile' onError="this.src='dummy.jpg';">
                    <!--<img class="img-circle-50" src="DR SITARAM.jpg" onError="this.src='dummy.jpg';">-->
                  </div>
                </div>
                <div class="row margin-left-zero margin-top-10">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px" *ngIf="SelectedPatientFormattedCode">{{SelectedPatientFormattedCode.DisplayName}}</label>
                  </div>
                </div>
                <div class="row margin-left-zero">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px" *ngIf="SelectedPatientFormattedCode">{{SelectedPatientFormattedCode.Gender}}/{{SelectedPatientFormattedCode.Age}}</label>
                  </div>
                </div>
                <div class="row margin-left-zero">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px" *ngIf="SelectedPatientFormattedCode">{{SelectedPatientFormattedCode.FormattedCode}}</label>
                  </div>

                </div>
                <div class="row margin-left-zero">
                  <div class="col-md-12 text-align-center padding-left-0px">
                    <label class="font-size-16px margin-bottom-0px" *ngIf="SelectedPatientFormattedCode">{{SelectedPatientFormattedCode.Telephone1}}</label>
                  </div>

                </div>

              </div>
            </div>

            <div class="row">
              <div class="col-md-12 padding-left-10px padding-right-0px">
                <div class="card">
                  <div class="card-header wh-header-tests  padding-bottom-0px padding-left-0px padding-right-0px padding-top-3px ">
                    Select Tests..
                  </div>
                  <div class="card-body padding-top-3px padding-bottom-3px padding-left-0px padding-right-0px">
                    <!--<ul id="myUL" *ngFor="let l of LabDepartments">
                      <li>
                        <span class="caret">{{l.LabType}}</span>
                        <ul [class]="'nested'+l.LabType" *ngFor="let m of GetTests(l.LabType)">
                          <li class="color-Assign font-weight-bold font-size-14">{{m.TestName}}</li>

                        </ul>
                      </li>
                    </ul>-->
                    
                      <div class="panel panel-default" *ngFor="let l of LabDepartments">
                        <div class="panel-heading">
                          <h4 class="panel-title padding-left-20px font-size-14p margin-bottom-0px" data-toggle="collapse" attr.data-target="#collapseOne{{l.LabDepartmentName}}">{{l.LabDepartmentName}}</h4>
                        </div>

                        <div [id]="'collapseOne'+l.LabDepartmentName" class="panel-collapse collapse">
                          <div class="panel-body" (click)="SelectedTest(m)" *ngFor="let m of GetTests(l.LabDepartmentName)">
                            <label class="margin-bottom-0px font-size-12px color-Assign font-weight-bold padding-left-20px">{{m.TestName}}</label>
                          </div>
                        </div>
                      </div>
                    
                  </div>
                </div>
              </div>
            </div>


          </div>

        </div>

      </div>
    </div>
  </div>

  <div class="columnnbv2-new  margin-top-17px">
    <div class="card col-md-9">
      <div class="card-header wh-header  padding-bottom-0px padding-left-0px padding-right-0px padding-top-0px">
        <div class="row margin-left-0px">
          <div class="col-md-12 padding-left-12px">
            <a class="nav-link-hand color-Assign font-size-18px font-weight-bold" title="Back To Results Entry" (click)="BackToProfile()"><i class="fas fa-angle-double-left font-size-18px nav-link-hand"></i> Lab Results Entry &amp; Signing</a>
          </div>
        </div>
        <div class="row border-bottom padding-bottom-3px margin-left-0px margin-right-0px padding-top-3px background-color-e4">
          <div class="col-md-3 padding-right-0px">
            <div class="row font-size-16px">
              <div class="col-md-5 padding-right-4px text-align-right">
                <label class="font-weight-bold font-size-12px margin-bottom-0px">Order Dt </label>
              </div>-
              <div class="col-md-4 padding-right-0px padding-left-3px text-align-left">
                <label class="font-weight-bold font-size-12px margin-bottom-0px color-Assign" *ngIf="Laborderdata">{{Laborderdata.EffectiveOrderDate| date:'MMM-dd-yyyy'}}</label>
              </div>
            </div>
          </div>
          <div class="col-md-2 padding-left-0px padding-right-0px">
            <div class="row font-size-16px">
              <div class="col-md-6   padding-right-2px padding-left-10px text-align-right">
                <label class="font-weight-bold font-size-12px margin-bottom-0px">Order Code </label>
              </div>-
              <div class="col-md-3 padding-right-0px padding-left-7px text-align-left">
                <label class="font-weight-bold font-size-12px margin-bottom-0px color-Assign" *ngIf="Laborderdata">{{Laborderdata.LabOrderCode}}</label>
              </div>
            </div>
          </div>
          <div class="col-md-4 padding-left-0px padding-right-0px">
            <div class="row font-size-16px">
              <div class="col-md-4  padding-right-10px text-align-right">
                <label class="font-weight-bold font-size-12px margin-bottom-0px">Branch </label>
              </div>-
              <div class="col-md-7 padding-right-0px padding-left-10px text-align-left">
                <label class="font-weight-bold font-size-12px margin-bottom-0px color-Assign" *ngIf="Laborderdata">{{Laborderdata.FacilityName}}</label>
              </div>
            </div>
          </div>
          <div class="col-md-3 padding-left-0px padding-right-0px">
            <div class="row font-size-16px margin-right-0px">
              <div class="col-md-4  padding-right-10px text-align-right">
                <label class="font-weight-bold font-size-12px margin-bottom-0px">Doctor </label>
              </div>-
              <div class="col-md-7 padding-right-0px padding-left-10px text-align-left">
                <label class="font-weight-bold font-size-12px margin-bottom-0px color-Assign" *ngIf="Laborderdata">{{Laborderdata.PrimaryDoctor}}</label>
              </div>
            </div>
          </div>


        </div>

      </div>
      <div class="card-body  padding-bottom-0px padding-left-0px padding-right-0px padding-top-10px">


 
        <!--<div class="row margin-left-0px">
          <div class="col-md-12 padding-left-12px">
            <a class="nav-link-hand color-Assign font-size-18px font-weight-bold" title="Back To Results Entry" (click)="BackToProfile()"><i class="fas fa-angle-double-left font-size-18px nav-link-hand"></i> Lab Results Entry &amp; Signing</a>
          </div>
        </div>-->
        <div class="row">

          <div class="col-md-12">
            <div class="row margin-right-0px margin-top-5px margin-bottom-5px" *ngIf="TestResultEntry && SelectedTestDetails">
              <div class="col-md-5 padding-right-0px ">
                <div class="row font-size-16px margin-right-0px margin-left-0px">
                  <div class="col-md-3 padding-right-4px text-align-right padding-left-11px">
                    <label class="font-weight-bold font-size-14 margin-bottom-0px">Test Name </label>
                  </div>-
                  <div class="col-md-7 padding-right-0px padding-left-3px text-align-left ">
                    <label class="font-weight-bold font-size-14 margin-bottom-0px color-Assign" *ngIf="SelectedTestDetails">{{SelectedTestDetails.TestName}}</label>
                  </div>
                </div>
              </div>
              <div class="col-md-4 padding-left-0px padding-right-0px">
                <div class="row font-size-16px">
                  <div class="col-md-4   padding-right-2px padding-left-10px text-align-right">
                    <label class="font-weight-bold font-size-14 margin-bottom-0px">Department </label>
                  </div>-
                  <div class="col-md-7 padding-right-0px padding-left-7px text-align-left">
                    <label class="font-weight-bold font-size-14 margin-bottom-0px color-Assign" *ngIf="SelectedTestDetails">{{SelectedTestDetails.LabDepartmentName}}</label>
                  </div>
                </div>
              </div>
              <div class="col-md-3">

                <div class="display-inline" *canUserAccess="['HL_LAB_5']">
                  <a *ngIf="SelectedTestDetails.OrderTestStatus=='Signed (2)' || SelectedTestDetails.OrderTestStatus=='Signed'"
                     class="nav-link-hand education-navlink data-color-new float-right margin-top-5px" (click)="tests()" title="print">
                    <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                  </a>
                </div>
                <div class="display-inline" *canUserAccess="['HL_LAB_Unsign']">
                  <button (click)="UnSign1()" type="button" class="btn actions-btn-prime  font-size-13px margin-right-5px float-right"
                          *ngIf="SelectedTestDetails.OrderTestStatus=='Signed' || SelectedTestDetails.OrderTestStatus=='Signed (1)' ||SelectedTestDetails.OrderTestStatus=='Signed (2)'">
                    UnSign
                  </button>
                </div>
                <div class="display-inline" *canUserAccess="['HL_LAB_4']">
                  <button (click)="Sign1()"
                          type="button" class="btn actions-btn-prime  font-size-13px margin-right-5px float-right"
                          *ngIf="CanSign1(SelectedTestDetails)">
                    Sign
                  </button>
                </div>
                <div class="display-inline">
                  <button (click)="Results()" type="button" class="btn actions-btn-prime  font-size-13px margin-right-5px float-right"
                          *ngIf="SelectedTestDetails.OrderTestStatus=='Results Pending' && isvisible">
                    Save
                  </button>
                </div>

                <!-- When Signing is done.. then unsign... -->
                
                
                <!--<button (click)="Sign()" type="button" class="btn actions-btn-prime  font-size-13px margin-right-5px float-right"
          *ngIf="CanSign2(SelectedTestDetails)">Sign</button>
  <button (click)="Sign()" type="button" class="btn actions-btn-prime  font-size-13px margin-right-5px float-right"
          *ngIf="CanSign3(SelectedTestDetails)">Sign</button>-->
                



              </div>
            </div>
            <div class="row margin-left-10px margin-right-0px" *ngIf="CurrentLabOrderTestResultsController">
              <div class="row col-12 margin-left-0px margin-right-0px">
                <!-- header -->
                <div class="col-md-4">
                  <label class="margin-bottom-0px font-weight-bold">
                    Observation
                  </label>
                </div>
                <div class="col-md-4">
                  <label class="margin-bottom-0px font-weight-bold">
                    Result
                  </label>
                </div>
                <div class="col-md-4">
                  <label class="margin-bottom-0px font-weight-bold">
                    Biological Normal Range
                  </label>
                </div>

              </div>

              <div class="row col-12 margin-left-0px margin-right-0px" *ngFor="let l  of ExaminationTypes">
                <div class="row col-12 margin-left-0px margin-right-0px background-lightblue margin-bottom-3px">
                  <label class="margin-bottom-0px font-weight-bold color-Assign">
                    {{l}}
                  </label>
                </div>
                <div class="row col-12 margin-left-0px margin-right-0px margin-bottom-3px"
                     *ngFor="let n of GetDetailsByExaminationType(SelectedTestDetails.TestName, l)">

                  <div class="col-md-4">
                    <label class="margin-bottom-0px">
                      {{n.ObservationName}}
                    </label>
                  </div>
                  <div class="col-md-4">
                    <input *ngIf="SelectedTestDetails.OrderTestStatus=='Results Pending'|| SelectedTestDetails.OrderTestStatus=='Results Entered'"
                           type="text" class="form-control-test text-align-left font-size-18px" placeholder="" (input)="Itemchange(l)"
                           [(ngModel)]="n.ObservationValue"
                           maxlength="15" required>

                    <label *ngIf="SelectedTestDetails.OrderTestStatus!='Results Pending' && SelectedTestDetails.OrderTestStatus!='Results Entered'">
                      {{n.ObservationValue}} / {{n.UOM}}
                    </label>
                  </div>
                  <div class="col-md-4">
                    <label class="margin-bottom-0px">
                      {{n.ReferenceRange}}
                    </label>
                  </div>


                </div>
              </div>

              <table hidden class="table table-striped margin-left-15px table-fixed"
                     cols="auto,2*,*,*,*,*,*,*">

                <thead class="">
                  <tr class="border-bottom-0px">
                    <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-5px min-width-32px">
                      #
                    </th>
                    <th class="padding-top-4px padding-bottom-4px th-sticky padding-left-0px">
                      Observation
                    </th>
                    <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-5px padding-left-10px">
                      Result
                    </th>
                    <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-5px padding-left-0px">

                    </th>
                    <th class="padding-top-4px padding-bottom-4px th-sticky padding-left-10px">
                      Biological Normal Range
                    </th>
                  </tr>
                </thead>
              </table>

              <div class="row" hidden>
                <div class="row"
                     *ngFor="let l  of ExaminationTypes">
                  <div class="row">
                    <label>{{l}}</label>
                    <div class="row">
                      <table class="table table-striped margin-left-15px table-fixed"
                             cols="auto,2*,*,*,*,*,*,*">
                        <tbody>
                          <tr class="border-bottom-0px" *ngFor="let n of GetDetailsByExaminationType(SelectedTestDetails.TestName, l) ; let RowIndex = index">
                            <td class="td-padding-tb padding-right-0px padding-left-5px">{{RowIndex+1}}</td>
                            <td class="td-padding-tb padding-right-0px padding-left-3px">{{n.ObservationName}}</td>
                            <td class="td-padding-tb">
                              <input *ngIf="SelectedTestDetails.OrderTestStatus=='Results Pending'|| SelectedTestDetails.OrderTestStatus=='Results Entered'"
                                     type="text" class="form-control-test text-align-left font-size-18px" placeholder="" (input)="Itemchange(l)"
                                     [(ngModel)]="n.ObservationValue"
                                     maxlength="10" required>

                              <label *ngIf="SelectedTestDetails.OrderTestStatus!='Results Pending' && SelectedTestDetails.OrderTestStatus!='Results Entered'">
                                {{n.ObservationValue}}
                              </label>
                              <!--<label *ngIf="SelectedTestDetails.OrderTestStatus=='Signed (2)' || SelectedTestDetails.OrderTestStatus=='Signed (1)'|| SelectedTestDetails.OrderTestStatus=='Signed'" class="margin-bottom-0px ">{{n.ObservationValue}}</label>-->
                            </td>
                            <td class="td-padding-tb padding-left-0px">{{n.UOM}}</td>
                            <td class="td-padding-tb td-elipsis padding-left-0px">
                              {{n.ReferenceRange}}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </div>

                </div>
              </div>
              <!--

  TestResultEntry && SelectedTestDetails &&
      <div class="chatsd product-chart-wrapper-Results agreement-chart-wrapper ps2 padding-lrt height-404px">-->
              <!--</div>-->
              <div class="col-md-12" hidden>

                <!--*ngIf="SelectedTestDetails.OrderTestStatus=='Results Pending'
    || SelectedTestDetails.OrderTestStatus=='Results Entered'"-->
                <div class="table-component">
                  <div class="table-responsive overflow-x">


                    <table class="table table-striped margin-left-15px table-fixed"
                           cols="auto,2*,*,*,*,*,*,*">

                      <thead class="">
                        <tr class="border-bottom-0px">
                          <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-5px min-width-32px">
                            #
                          </th>
                          <th class="padding-top-4px padding-bottom-4px th-sticky padding-left-0px">
                            Observation
                          </th>
                          <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-5px padding-left-10px">
                            Result
                          </th>
                          <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-5px padding-left-0px">

                          </th>
                          <th class="padding-top-4px padding-bottom-4px th-sticky padding-left-10px">
                            Biological Normal Range
                          </th>
                        </tr>
                      </thead>

                      <tbody class="table-body">
                        <!--<tr class="border-bottom-0px" *ngFor="let examinationType of ExaminationType">
              <td class="td-padding-tb padding-right-0px padding-left-3px">{{examinationType}}</td>

            </tr>-->

                        <tr class="border-bottom-0px" *ngFor="let et of ExaminationTypes ">
                          <td>
                            <div>
                              <table>
                                <thead>
                                  <tr>
                                    <th>{{et}}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr class="border-bottom-0px" *ngFor="let n of GetDetailsByExaminationType(SelectedTestDetails.TestName, et) ; let RowIndex = index">
                                    <td class="td-padding-tb padding-right-0px padding-left-5px">{{RowIndex+1}}</td>
                                    <td class="td-padding-tb padding-right-0px padding-left-3px">{{n.ObservationName}}</td>
                                    <td class="td-padding-tb">
                                      <input *ngIf="SelectedTestDetails.OrderTestStatus=='Results Pending'|| SelectedTestDetails.OrderTestStatus=='Results Entered'"
                                             type="text" class="form-control-test text-align-left font-size-18px" placeholder="" (input)="Itemchange(l)"
                                             [(ngModel)]="n.ObservationValue"
                                             maxlength="10" required>

                                      <label *ngIf="SelectedTestDetails.OrderTestStatus!='Results Pending' && SelectedTestDetails.OrderTestStatus!='Results Entered'">
                                        {{n.ObservationValue}}
                                      </label>
                                      <!--<label *ngIf="SelectedTestDetails.OrderTestStatus=='Signed (2)' || SelectedTestDetails.OrderTestStatus=='Signed (1)'|| SelectedTestDetails.OrderTestStatus=='Signed'" class="margin-bottom-0px ">{{n.ObservationValue}}</label>-->
                                    </td>
                                    <td class="td-padding-tb padding-left-0px">{{n.UOM}}</td>
                                    <td class="td-padding-tb td-elipsis padding-left-0px">
                                      {{n.ReferenceRange}}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>

                      </tbody>



                    </table>
                  </div>
                </div>
                <div hidden class="table-component" *ngIf="SelectedTestDetails.OrderTestStatus=='Signed (2)' || SelectedTestDetails.OrderTestStatus=='Signed (1)'|| SelectedTestDetails.OrderTestStatus=='Signed'">
                  <div class="table-responsive overflow-x">


                    <table class="table table-striped margin-left-15px table-fixed"
                           cols="auto,2*,*,*,*,*,*,*">

                      <thead class="">
                        <tr class="border-bottom-0px">





                          <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-5px min-width-32px">
                            #
                          </th>
                          <th class="padding-top-4px padding-bottom-4px th-sticky padding-left-0px">
                            Observation
                          </th>
                          <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-5px padding-left-10px">
                            Result
                          </th>

                          <th class="padding-top-4px padding-bottom-4px th-sticky padding-left-0px">
                            Biological Normal Range
                          </th>






                        </tr>
                      </thead>

                      <tbody class="table-body">
                        <tr class="border-bottom-0px" *ngFor="let n of GetDetails(SelectedTestDetails.TestName) ; let RowIndex = index">




                          <td class="td-padding-tb padding-right-0px padding-left-5px">{{RowIndex+1}}</td>
                          <td class="td-padding-tb padding-right-0px padding-left-3px">{{n.ObservationName}}{{n.ExaminationType}}</td>
                          <td class="td-padding-tb">
                            <!--<input *ngIf="SelectedTestDetails.OrderTestStatus=='Results Pending' || SelectedTestDetails.OrderTestStatus=='Resutls Entered'" type="text" class="form-control-test text-align-right font-size-18px" placeholder="" (input)="Itemchange(l)"
                [(ngModel)]="n.ObservationValue"
                maxlength="10" required>-->
                            <label class="margin-bottom-0px ">{{n.ObservationValue}}{{n.UOM}}</label>
                          </td>

                          <td class="td-padding-tb td-elipsis padding-left-3px">
                            {{n.ReferenceRange}}
                          </td>




                          <!--<td class="td-padding-tb text-align-center padding-right-0px padding-left-10px"> </td>
              <td class="text-align-center td-padding-tb"></td>-->
                          <!--<td class=" td-padding-tb text-align-center">
                <input type="checkbox" class="width-23px height-16px margin-top-3px" />
                <i class="input-helper"></i>
              </td>
              <td class=" td-padding-tb text-align-center">
                <input type="checkbox" class="width-23px height-16px margin-top-3px" />
                <i class="input-helper"></i>
              </td>-->


                        </tr>
                      </tbody>



                    </table>
                  </div>
                </div>
              </div>

            </div>
            <div class="row margin-left-15px margin-right-0px padding-bottom-10px" *ngIf="TestResultEntry && SelectedTestDetails">
              <div class="col-md-12">
                <div>
                  <label class="margin-bottom-0px margin-top-5px">Comments </label>
                </div>
                <div class="form-group margin-bottom-0px">
                  <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                  <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                  [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                  name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                  <textarea class="form-control3 col-md-11" rows="2" placeholder="Comments"
                            [(ngModel)]="SelectedTestDetails.Remarks" required></textarea>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--<div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
          <div class="card">


            <div class="card-header wh-header border-bottom padding-bottom-0px">
              <div class="row border-bottom">
                <div class="col-md-4">
                  <label class="margin-bottom-0px">Discount : </label>
                </div>
                <div class="col-md-4">
                  <label class="margin-bottom-0px">Discount(%) :</label>
                </div>
                <div class="col-md-4">
                  <label class="margin-bottom-0px">Total :</label>
                </div>
              </div>
            </div>






          </div>
        </div>
      </div>-->




    </div>
  </div>




</div>
